const _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "4769bbde4c3c6910abeeb3a43f17c7f0d8b1e980"
};